import * as DisplaySelectors from './display';
import * as EditableSelectors from './editable';
import { editable as _editable, editables as _editables } from './editable';
import * as SettingSelectors from './setting';
export var Selectors = {
  Display: DisplaySelectors,
  Setting: SettingSelectors,
  Editable: EditableSelectors
};
export var selectors = function selectors(store) {
  return {
    editable: function editable(id) {
      return _editable(store.getState(), {
        id: id
      });
    },
    editables: function editables(id) {
      return _editables(store.getState());
    }
  };
};
export { _editable as editable, _editables as editables };